import React from 'react'

import { MailIcon } from 'components/Utils/Icons'
import { connect } from 'react-redux'
import RoutesHelper from 'helpers/RoutesHelper'
import history from 'browserHistory'
import { selectors as ApplicationsSelectors } from 'data/applications'
import ApplicationIconHolder from './ApplicationIconHolder'
import { selectors as ConfigSelectors } from 'data/config'
import { selectors as NoteSelectors } from 'data/notes'
import { setActiveModal } from 'data/ui/actions'
import { NOTES_SHARE_TO_SLACK } from 'components/Utils/Modal/constants'
import {
  getActiveIconByName,
  getGreyIconByName,
} from '@slite/editor/lib/components/ApplicationIcons'
import { SlackIcon, SlackIconMonochrome } from 'components/Utils/Icons'

class ShareTo extends React.Component {
  handleShareToApplication = application => {
    const { eventBusStore, closePopover } = this.props

    closePopover()

    if (application.isInstalled) {
      return eventBusStore.updateItem('event', {
        type: 'showShareToModal',
        metadata: {
          selectedText: '',
          integration: {
            id: application.integration.id,
            application,
          },
        },
      })
    }

    history.push(
      RoutesHelper.settingsIntegrationApplicationDetails({
        applicationId: application.id,
      })
    )
  }

  handleShareToSlack = application => {
    const { closePopover, eventBusStore, activeNote } = this.props

    closePopover()
    if (!application.isInstalled) {
      return this.props.setActiveModal({
        id: NOTES_SHARE_TO_SLACK,
        meta: { noteId: activeNote.id },
      })
    }

    eventBusStore.updateItem('event', {
      type: 'showShareToModal',
      metadata: {
        selectedText: '',
        integration: {
          id: application.integration.id,
          application,
        },
      },
    })
  }

  getApplicationIcon(application) {
    if (application.id === this.props.slackClientId) {
      return application.isInstalled ? SlackIcon : SlackIconMonochrome
    }
    return application.isInstalled
      ? getActiveIconByName(application.name)
      : getGreyIconByName(application.name)
  }

  render() {
    const { toggleOnEmailForm, applications = [], slackClientId } = this.props

    return (
      <div className="flexbox flexbox-align-center background-shade-50 padding-vertical-medium padding-horizontal-large">
        <ApplicationIconHolder
          id="email"
          tooltipContent={'Share doc by e-mail'}
          onClick={event => {
            event.preventDefault()
            event.stopPropagation()
            toggleOnEmailForm()
          }}
        >
          <MailIcon size={16} />
        </ApplicationIconHolder>

        {applications.map(application => {
          const Icon = this.getApplicationIcon(application)

          if (!Icon) {
            return null
          }

          return (
            <ApplicationIconHolder
              key={application.id}
              id={application.id}
              className="margin-left-normal"
              tooltipContent={
                application.isInstalled
                  ? `Share to ${application.name}`
                  : `Install ${application.name}`
              }
              onClick={() => {
                if (!this.props.activeNote) {
                  return null
                }

                if (application.id === slackClientId) {
                  return this.handleShareToSlack(application)
                }

                return this.handleShareToApplication(application)
              }}
            >
              <Icon size={16} />
            </ApplicationIconHolder>
          )
        })}
      </div>
    )
  }
}

export default connect(
  state => {
    const applications = ApplicationsSelectors.getApplications(state)

    return {
      activeNote: NoteSelectors.getActiveNote(state),
      slackClientId: ConfigSelectors.getSlackAppSliteClientId(state),
      applications: applications.map(application => application.toJS()),
    }
  },
  { setActiveModal }
)(ShareTo)
